import styled from "styled-components";

export const IconRow = styled.div`
    display: flex;
    margin-bottom: 0.6em;
    gap: 0.7em;
    margin-left: 1em;
`;

export const AdjustedIcon = styled.div`
    position: relative;
    top: -13px;
`;

export const Description = styled.span`
    font-size: 0.9em;
    line-height: 1.35;
    position: relative;
    top: -6px;
    margin-left: 0.7em;

`;